export const en = {
	en: {
		finscanTitle: "FinCR",
		signUp: "Sign Up",
		finscanLogin: "FinCR Login",
		noAccount: "Don’t have an Account yet?",
		registerHere: "Register here.",
		loginError: "Could not sign in.",
		login: "Sign In",
		toLoginPage: "Zum Login",
		logout: "Logout",
		users: "Users",
		user: "User",
		upload: "Upload",
		ocr: "OCR",
		download: "Download",
		documentUpload: "Document Upload",
		uploadDocumentsPrompt: "Drag documents here or click the button",
		selectFile: "Select file",
		uploadedDocuments: "Uploaded Documents",
		noDocumentsUploaded: "No documents uploaded",
		startOcr: "Start OCR",
		documentName: "Document Name",
		scanDate: "Scan Date",
		results: "Results",
		step: "Step",
		progress: "Progress",
		status: "Status",
		action: "Action",
		review: "Review",
		noData: "No data",
		next: "Next",
		documentType: "Document Type",
		fincrCreateAccount: "FinCR Account erstellen",
		createAccountDescription:
			"Um die Registrierung abzuschließen, legen Sie bitte ein Passwort für Ihr Benutzerkonto fest.",
		fincrResetPassword: "FinCR Passwort zurücksetzen",
		resetPasswordDescription:
			"Bitte geben Sie ein neues Passwort für ihr FinCR Konto ein.",
		deleteDocModalQuestion: "Möchten Sie dieses Dokument löschen?",
		yes: "Ja",
		no: "Nein",
		adminPanel: {
			finscanAdminLogin: "FinCR Admin Login",
			accountInformation: "Account Information",
			documents: "Documents",
			billing: "Billing",
			customer: "Customer",
			userID: "User Id",
			accountManagement: "Account Management",
			resetPassword: "Reset Password",
			deactivateAccount: "Deactivate Account",
			activateAccount: "Activate Account",
			deleteAccount: "Delete Account",
			noData: "No data",
			next: "Next",
			yes: "Yes",
			no: "No",
			resetPasswordModalQuestion:
				"Are you sure you want to reset this user's password?",
			activateAccountModalQuestion:
				"Are you sure you want to activate this user's account?",
			deactivateAccountModalQuestion:
				"Are you sure you want to deactivate this user's account?",
			deleteAccountModalQuestion:
				"Are you sure you want to delete this user's account?",
			passwordResetSuccessful: "Password reset successfully.",
			passwordResetNotSuccessful: "Could not reset password.",
			activateAccountSuccessful: "Account activated successfully.",
			activateAccountNotSuccessful: "Could not activate account.",
			deactivateAccountSuccessful: "Account deactivated successfully.",
			deactivateAccountNotSuccessful: "Could not deactivate account.",
			deleteAccountSuccessful: "Account deleted successfully.",
			deleteAccountNotSuccessful: "Could not delete account.",
			usersTable: {
				allUsers: "All Users",
				userID: "User number",
				userEmail: "Email",
				userAccountType: "Account Type",
				userCreatedDate: "Created Date",
				userLink: "",
				isRegistered: "Registered",
				isEnabled: "Enabled",
				companyName: "Company",
			},
		},
		correctionsTable: {
			other: "Other",
			otherCorrection: "Other - Correction",
			accountNumber: "Account No",
			accountNumberCorrection: "Account No - Correction",
			description: "Description",
			descriptionCorrection: "Description - Correction",
			subaccount: "Value (Subaccounts)",
			subaccountCorrection: "Value - Correction",
			currentYear: "Value (Current Year)",
			currentYearCorrection: "Value - Correction",
			prevYear: "Value (Previous Year)",
			prevYearCorrection: "Value - Correction",
		},
		forms: {
			labels: {
				email: "E-Mail",
				password: "Password",
				passwordRepeat: "Repeat password",
			},
			errors: {
				email: "Please enter your email",
				password: "Please enter your password",
			},
		},
		errorMessages: {
			passwordDoNotMatch: "The passwords do not match.",
			termsAndConditionsNotAccepted:
				"You must accept the terms and conditions and data security agreement to continue.",
			passwordInvalid:
				"Your password must be a minimum of 8 characters long, and include a minimum 1 each letter, capital letter, number and special character",
			registrationError: "Could not register.",
			forms: {
				docInvalid: "You can only upload .pdf files.",
				fileIsDuplicate:
					"You are not allowed to upload the same file more than once.",
				fileOverMaxSize:
					"The file is bigger than the maximum allowed file size of 200MB.",
				maxNumberOfFilesReached:
					"You are only permitted to upload 5 files.",
				docTypeInvalid: "Please select document type.",
			},
		},
		feedbackMessages: {
			uploadSuccessful: "Files uploaded successfully.",
			userAccountCreatedSuccessful:
				"Ihr Benutzerkonto wurde erfolgreich erstellt.",
			passwordResetSuccessful: "Ihr Passwort wurde erfolgreich geändert.",
			loginPrompt: "Bitte melden Sie sich an, um FinCR zu nutzen.",
		},
		passwordRules: {
			title: "Passwortrichtlinien",
			description: "Ihr Passwort muss mindestens folgendes beinhalten:",
			ruleOne: "- 7 Zeichen",
			ruleTwo: "- 1 Buchstabe",
			ruleThree: "- 1 Zahl",
			ruleFour: "- 1 Sonderzeichen",
		},
		faqTitle: "FAQ",
	},
};
